import type { TECContainerColor } from '../types';

const DARK_BACKGROUNDS = ['charcoal', 'charcoalTint'];

export const getContainerBackgroundType = (backgroundColor?: TECContainerColor | '') => (DARK_BACKGROUNDS.includes(backgroundColor || '')) ? 'light' : 'dark';
